import { render, staticRenderFns } from "./VueLink.vue?vue&type=template&id=64613f90&"
import script from "./VueLink.vue?vue&type=script&lang=js&"
export * from "./VueLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports